// constants
import { BASE_GUTTER_SPACE } from 'shared/styles/base';

export const CAV_DWEB_CONSTANTS = {
  imageGutter: BASE_GUTTER_SPACE * 1.5,
  margin: BASE_GUTTER_SPACE * 3,
  width: 267,
  minimumWidgetCount: 3,
};
